export default __webpack_public_path__ + "static/media/holder.a66fce9c.png";